import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'
import colors from '../../design/color-names'
import tokens from '../../design/tokens'
import { IconQuestion } from '../SVGIcons/IconQuestion'

const StyledIconQuestion = styled(IconQuestion)`
  cursor: default;
  margin-left: ${tokens.spacing.xSmall};
  color: ${colors.silverChalice};
  font-size: 15px;
  transition: color 0.25s ease;

  &:hover {
    color: ${colors.blueChill};
    cursor: pointer;
  }
`

export const HelpIcon = ({
  className,
  text,
  'data-mu-test': dataAttributeTest,
  'data-for': dataFor,
  'data-tip': dataTip,
  inline
}) => {
  return (
    <StyledIconQuestion
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={text || dataTip}
      inline={inline}
      data-for={dataFor}
    />
  )
}

HelpIcon.defaultProps = {
  inline: true,
  'data-tip': false
}

HelpIcon.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  'data-mu-test': PropTypes.string,
  inline: PropTypes.bool,
  'data-for': PropTypes.string,
  'data-tip': PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}
